export default __webpack_public_path__ + "static/media/edward-burns.22bf6f7f.png";